/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type RoleType = 'Unknown' | 'Administrator' | 'ClinicOwner' | 'Clinic' | 'Veterinarian' | 'Owner' | 'Manager';

export const RoleType = {
    Unknown: 'Unknown' as RoleType,
    Administrator: 'Administrator' as RoleType,
    ClinicOwner: 'ClinicOwner' as RoleType,
    Clinic: 'Clinic' as RoleType,
    Veterinarian: 'Veterinarian' as RoleType,
    Owner: 'Owner' as RoleType,
    Manager: 'Manager' as RoleType
};